export default {
  /**
   * 输入最长限制 <= max 默认 50
   */
  inputMaxLimit: (max = 50) => ({
    validator: (rule, value) => {
      if (value?.length > max) {
        return Promise.reject(new Error(`请勿超过${max}个字符`))
      }
      return Promise.resolve()
    },
  }),
  /**
   *
   * @param phoneNumber 手机号码
   * @returns 校验手机号码
   */
  validatePhoneNumber: () => ({
    validator: (rule, value) => {
      const phoneNumberRegex = /^1[3456789]\d{9}$/
      if (phoneNumberRegex.test(value)) {
        return Promise.resolve()
      }
      return Promise.reject(new Error('请输入正确的手机号码'))
    },
  }),
}

/**
 * 校验空
 * @param rule 
 * @param value 
 * @returns 
 */
export const validateEmpty = (rule, value) => {
  if (value === null || value === undefined) {
    return Promise.reject()
  }
  if (typeof value === 'number' && Number.isNaN(value)) {
    return Promise.reject()
  }
  if (typeof value === 'string' && !value.trim()) {
    return Promise.reject()
  }
  if (typeof value === 'object' && !Object.keys(value).length) {
    return Promise.reject()
  }
  if (Array.isArray(value) && !value.length) {
    return Promise.reject()
  }

  return Promise.resolve()
}

export const validateInputNumberSelectEmpty = (rule, value, message?: {inputMessage: string; selectMessage: string}) => {
  if (!value || value.inputValue === null || value.inputValue === undefined || Number.isNaN(value.inputValue)) {
    return Promise.reject(new Error(message?.inputMessage || '请输入'))
  }
  if (!value.selectValue || !value.selectValue.trim()) {
    return Promise.reject(new Error(message?.selectMessage || '请选择'))
  }
  return Promise.resolve()
}
